"use strict";
/*
 * How to use?
 *
 *
import { getStaticPageApiUrl } from '@empiriecom/module-inspire-components/utils/apiUrl.staticPage';

const finalUrl = getStaticPageApiUrl({
  language: 'de',
  pathname: '/',
  url: '/api/inspire/pages/<localeApi>/<page>.json'
})
 * */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStaticPageApiUrl = void 0;
var getStaticPageApiUrl = function (_a) {
    var language = _a.language, pathname = _a.pathname, _b = _a.url, url = _b === void 0 ? '' : _b;
    var currentPathname = pathname;
    var currentUrl = url;
    // avoid double slashes due trailing slash in currentPathname
    currentPathname = currentPathname
        .replace(/^\/+/, '')
        .replace('preview/', '')
        .replace('preview-app/', '');
    if (currentPathname.startsWith(language + "/")) {
        currentPathname = currentPathname.replace(language + "/", '');
    }
    var returnVal = currentUrl
        ? currentUrl
            .replace('<localeApi>', language)
            .replace('<page>', currentPathname.replace(/\/$/, '').replace(/\//g, '-'))
        : null;
    return returnVal;
};
exports.getStaticPageApiUrl = getStaticPageApiUrl;
//# sourceMappingURL=apiUrl.staticPage.js.map